import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./goh-account-ui.css";

/* =========================================================
   Sticky back bar for pages that lack the main header
   (Profile, settings, etc). Goes back through in-app history
   when there is any; otherwise falls back to a safe route,
   so a cold deep-link still has somewhere to go.

   Usage at the top of ProfilePage:
     <BackBar title="My profile" />
   Optional: fallback="/hub" (default), right={<button…/>}
   ========================================================= */
export default function BackBar({ title = "", fallback = "/hub", right = null }) {
  const navigate = useNavigate();

  const handleBack = () => {
    const idx =
      typeof window !== "undefined" && window.history.state
        ? window.history.state.idx
        : 0;

    if (idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <div className="goh-backbar">
      <button
        type="button"
        className="goh-backbar__btn"
        onClick={handleBack}
        aria-label="Go back"
      >
        <FaArrowLeft aria-hidden="true" />
      </button>

      <span className="goh-backbar__title">{title}</span>

      <span className="goh-backbar__right">{right}</span>
    </div>
  );
}
